import { render, staticRenderFns } from "./ConsumablesDetail.vue?vue&type=template&id=b4be1bba&scoped=true"
var script = {}
import style0 from "./ConsumablesDetail.vue?vue&type=style&index=0&id=b4be1bba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4be1bba",
  null
  
)

export default component.exports